export default "/bundles/assets/attachment_doc_858fe1e609b8f8b5f3b261d529ce8108.png";